
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { PatientToothChart, PatientToothChartHeader } from '../../../interfaces/masters/patienttoothchart';

@Injectable()
export class patientToothChartApi {

  private readonly apiController: string = 'diagnosis';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({ "Accept": "application/vnd.ezovion.hateoas+json" });
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url, { headers: { "Accept": "application/vnd.ezovion.hateoas+json", 'Content-Type': "application/json" } });
  }

  add(url: string, data: PatientToothChart[]): Observable<PatientToothChart[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost( url, data, header);
  }

  addHeader(url: string, data: PatientToothChartHeader): Observable<PatientToothChartHeader> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept', 'application/vnd.ezovion.hateoas+json');
    return this.api.directPost(url, data, header);
  }

  
  update(url: string, data: PatientToothChartHeader):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  updatedtl(url: string, data: PatientToothChart): Observable<any> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept', 'application/vnd.ezovion.hateoas+json');
    return this.api.directPut(url, data, { headers: { "Accept": "application/vnd.ezovion.hateoas+json", 'Content-Type': "application/json" } });
  }
  
  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
